import styled from 'styled-components';

/**
 * @component Container
 * @description Wrapper for invoice status badge
 */
export const Container = styled.div`
  display: inline-flex;
`;
